import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { memo } from 'react';
import styles from './Tooltip.module.css';

type Props = {
  name: string;
  description: string;
  color?: string;
  position?: Array<number | string | null>;
  size?: string;
};

const ToolTip = memo(
  ({
    name,
    description,
    color = 'rgb(27, 83, 149)',
    position = [null, '7px', null, null],
    size = '16px',
  }: Props) => {
    return (
      <div className={styles.tooltip}>
        <FontAwesomeIcon
          style={{
            color,
            // Inline styles use `undefined` (not `null`) for an unset value.
            top: position[0] ?? undefined,
            right: position[1] ?? undefined,
            bottom: position[2] ?? undefined,
            left: position[3] ?? undefined,
            fontSize: size,
          }}
          icon={faInfoCircle}
          className={styles.chartsInfoIcon}
        />
        <span className={styles.tooltiptext}>
          <p>
            <b>{name}</b>
            <br />
            {description}
          </p>
        </span>
      </div>
    );
  }
);

export default ToolTip;
